import React, { useEffect, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { validation } from '../../../shared/form-validations';
import { textInput, selectField } from '../../../shared/form-elements'
import { reduxForm, Field, reset, change } from "redux-form";
import { Button, Modal } from 'react-bootstrap';
import { CircleCheckBox } from '../../../shared/form-elements/CircleCheckBox';
import { useDetectOutsideClick } from '../../../utils/useDetectOutsideClick';

function StageForm(props) {
  const { 
    handleSubmit, 
    newForm , 
    editStage, 
    goupId, 
    stage_error, 
    handleCloseForm, 
    request_approval, 
    className,
    style,
    formRef
  } = props
  const dispatch = useDispatch();
  const defaultName = 'Untitled';

  useEffect(() => {
    if(newForm === "newForm") {
      dispatch(change("stageform", "name", defaultName))
      dispatch(change("stageform", "workspace_id", goupId));
      dispatch(change("stageform", "visible_to_client", false))
      dispatch(change("stageform", "require_approval_from_client", false));
      dispatch(change("stageform", "enable_timestamp", false));
      dispatch(change("stageform", "enable_revision", false));
    }
    document.getElementById("input_foucus").focus();
  }, []);

  return (
    <div 
      className={className} 
      style={style}
      ref={formRef}
    >
        {stage_error.error && stage_error.error.map((data, index) => (
          <div className="error_message" key={index}>{data}</div>
        ))}
        <div className="col-lg-12">
          <form onSubmit={handleSubmit}>
            <Field name="workspace_id" type="hidden" component={textInput}/>
            <div className="mb-3">
              <Field 
                name="name" 
                type="text" 
                component={textInput} 
                id="input_foucus"
                input_class_name='form-control rounded-corners'
                placeholder='Add stage name'
              /> 
            </div>
            <h4 className='stage_settings-title mb-2 p-1'>Stage Settings</h4>
            {request_approval && (
              <>
                <div className="stage_settings-field  rounded-corners my-1 p-1">
                  <Field name="enable_revision" component={CircleCheckBox} label="Revision Count"/>
                </div>
                <div className="stage_settings-field  rounded-corners my-1 p-1">
                  <Field name="enable_timestamp" component={CircleCheckBox} label="Enable Timestamp"/>
                </div>

                <div className="stage_settings-field  rounded-corners my-1 p-1">
                  <Field name="visible_to_client" component={CircleCheckBox} label="Visible to Guest"/>
                </div>

                <div className="stage_settings-field  rounded-corners my-1 mb-4 p-1">
                  <Field name="require_approval_from_client" component={CircleCheckBox} label="Requires Approval"/>
                </div>
              </>

            )}
            <div className="d-grid">
              <Button 
                variant="success" 
                type="submit" 
                className='rounded-corners mb-6px' 
                size="sm"
              >
                {
                  newForm ?
                    'Add'
                  :
                    'Submit'
                }
              </Button>
              <Button variant="transparent" onClick={handleCloseForm} size="sm" className='rounded-corners'>
                Cancel
              </Button>
            </div>
          </form>
        </div>
      </div>
  );
}

StageForm =  reduxForm({
  form: 'stageform',
  validate: validation,
  enableReinitialize: true
})(StageForm);

const mapStateToProps = (state) => {
  return {
    loading: state.stage.loading,
    error: state.stage.error,
    editStage: state.stage.editStage,
    can_access_approval_request: state.stage.can_access_approval_request,
    initialValues: {
      name: state.stage.editStage && state.stage.editStage.data && state.stage.editStage.data.name,
      visible_to_client: state.stage.editStage && state.stage.editStage.data && state.stage.editStage.data.visible_to_client,
      workspace_id: state.stage.editStage && state.stage.editStage.data && state.stage.editStage.data.workspace_id,
      require_approval_from_client: state.stage.editStage && state.stage.editStage.data && state.stage.editStage.data.require_approval_from_client,
      enable_timestamp: state.stage.editStage?.data?.enable_timestamp,
      enable_revision: state.stage.editStage?.data?.enable_revision
    }
  };
};

export default connect(mapStateToProps,{})(StageForm);
